"use strict";

exports.__esModule = true;
exports.ClassificationButtonGroup = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _getPlantStateColor = require("../../PlantStateActivities/getPlantStateColor");
var _excluded = ["label", "state", "theme", "children"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var ClassificationButtonGroupInner = _styledComponents["default"].div.withConfig({
  displayName: "ClassificationButtonGroupmodern__ClassificationButtonGroupInner",
  componentId: "sc-djmi8a-0"
})(["margin:12px 0 24px;display:grid;grid-template-columns:repeat(auto-fill,minmax(260px,1fr));grid-column-gap:14px;grid-row-gap:14px;"]);

// Section header from the next-gen design: a coloured dot, the state in small
// caps, and its short code in a chip.
var GroupHeader = _styledComponents["default"].div.withConfig({
  displayName: "ClassificationButtonGroupmodern__GroupHeader",
  componentId: "sc-djmi8a-1"
})(["display:flex;align-items:center;gap:8px;font-size:12px;font-weight:700;letter-spacing:0.07em;text-transform:uppercase;color:#5a6771;"]);
var Dot = _styledComponents["default"].span.withConfig({
  displayName: "ClassificationButtonGroupmodern__Dot",
  componentId: "sc-djmi8a-2"
})(["width:10px;height:10px;border-radius:3px;flex:none;background:", ";"], function (props) {
  return props.$color || "#c7cfd5";
});
var Chip = _styledComponents["default"].span.withConfig({
  displayName: "ClassificationButtonGroupmodern__Chip",
  componentId: "sc-djmi8a-3"
})(["font-family:ui-monospace,Menlo,Consolas,\"DejaVu Sans Mono\",monospace;font-size:11.5px;font-weight:600;letter-spacing:0;text-transform:none;padding:1px 6px;border-radius:4px;background:#f1f4f6;color:#5a6771;"]);
var SHORT_CODES = {
  "downtime.unplanned": "UDT",
  "downtime.planned": "PDT"
};
var ClassificationButtonGroup = exports.ClassificationButtonGroup = (0, _styledComponents.withTheme)(function (props) {
  var label = props.label,
    state = props.state,
    theme = props.theme,
    children = props.children,
    extra = _objectWithoutPropertiesLoose(props, _excluded);
  var color = state ? (0, _getPlantStateColor.getPlantStateColor)(theme, state.id) : undefined;
  var code = state ? SHORT_CODES[state.id] : undefined;
  return /*#__PURE__*/_react["default"].createElement("section", extra, label && /*#__PURE__*/_react["default"].createElement(GroupHeader, null, /*#__PURE__*/_react["default"].createElement(Dot, {
    $color: color
  }), /*#__PURE__*/_react["default"].createElement("span", null, label), code && /*#__PURE__*/_react["default"].createElement(Chip, null, code)), /*#__PURE__*/_react["default"].createElement(ClassificationButtonGroupInner, null, children));
});